export const setBreadcrumb = (param) => {
  return (dispatch) => {
    dispatch({ type: "BREADCRUMB", data: param });
  }
};

export const uploadProgress = (param) => {
  return (dispatch) => {
    dispatch({ type: "PROGRESS", data: param });
  }
};
export const set_param_first = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_PARAM_FIRST", data: param });
  }
};

export const set_page = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_PAGE", data: param });
  }
};

export const set_archive_filter = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_ARCHIVE_FILTER", data: param });
  }
};